export const UserCoupleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path d="M14.407,19.385,14.75,23.5h4l.5-6h2.5V14a5,5,0,0,0-8-4" fill="#c4f0eb" />
      <path
        d="M16.75,9a4.978,4.978,0,0,0-3,1l.138,1.976a4.986,4.986,0,0,1,7.862,4.087V14A5,5,0,0,0,16.75,9Z"
        fill="#ffffff"
      />
      <path
        d="M14.407,19.385,14.75,23.5h4l.5-6h2.5V14a5,5,0,0,0-8-4"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={16.75} cy={4} r={3.5} fill="#c4f0eb" />
      <path d="M9.75,23.5l.5-6h2.5V14a5,5,0,0,0-10,0v3.5h2.5l.5,6Z" fill="#c4f0eb" />
      <circle cx={7.75} cy={4} r={3.5} fill="#c4f0eb" />
      <path
        d="M11.25,4a3.383,3.383,0,0,1-.15,1.01,3.5,3.5,0,0,0-6.7,0A3.383,3.383,0,0,1,4.25,4a3.5,3.5,0,0,1,7,0Z"
        fill="#ffffff"
      />
      <path d="M7.75,9a5,5,0,0,0-5,5v2.019a5,5,0,0,1,10,0V14A5,5,0,0,0,7.75,9Z" fill="#ffffff" />
      <path
        d="M9.75,23.5l.5-6h2.5V14a5,5,0,0,0-10,0v3.5h2.5l.5,6Z"
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={7.75}
        cy={4}
        r={3.5}
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.25,4a3.383,3.383,0,0,1-.15,1.01,3.5,3.5,0,0,0-6.7,0A3.383,3.383,0,0,1,13.25,4a3.5,3.5,0,0,1,7,0Z"
        fill="#ffffff"
      />
      <circle
        cx={16.75}
        cy={4}
        r={3.5}
        fill="none"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
